import * as React from "react";
import { styled } from "@mui/system";
import MUIStepConnector from "@mui/material/StepConnector";
import { StepConnectorProps as StepConnectorPropsMUI } from "@mui/material/StepConnector";
export interface StepConnectorProps extends StepConnectorPropsMUI {}

const StepConnectorRoot = styled(MUIStepConnector, {
  name: "StepConnector",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) => ({
  "&.MuiStepConnector-root .MuiStepConnector-line": {
    borderColor: theme.palette.primary.primaryBackgroundHover + " !important"
  }
}));

export const StepConnector = React.forwardRef<
  HTMLDivElement,
  StepConnectorProps
>(function StepConnector(props, ref) {
  return <StepConnectorRoot {...props} ref={ref} />;
}) as React.FC<StepConnectorProps>;
